const PlayerBonusStatusTypeName = "PlayerBonusStatus";
const PlayerBonusViewModelKeysTypeName = "PlayerBonusViewModelKeys";
const PlayerBonusQueryFieldsTypeName = "PlayerBonusQueryFields";
const PlayerBonusColumnTypeName = "PlayerBonusColumn";
export {
  PlayerBonusColumnTypeName,
  PlayerBonusQueryFieldsTypeName,
  PlayerBonusStatusTypeName,
  PlayerBonusViewModelKeysTypeName
};
//# sourceMappingURL=constants.js.map
